import React from "react";
import Hero from "../../components/Hero/Hero";
import Features from "../../components/Features/Features";
import Nails from "../../components/NailsMenu/Nails";

import { heroOne, heroTwo, heroThree } from "../../data/homeData";
import Beauty from "../../components/BeautyMenu/Beauty";
// import Fbchat from "../../components/Fbchatplusgin/Fbchat";
import Fbpost from "../../components/Fbchatplusgin/Fbpost";
import Instagram from "../../components/Fbchatplusgin/instagram";
import Location from "../../components/Location/Location";

const HomePage = () => {
  return (
    <>
      <Hero />
      <Location />
      <Features {...heroOne} />
      <Nails />
      <Beauty />
      {/* <Fbchat /> */}
      <Fbpost />
      <Instagram />
    </>
  );
};

export default HomePage;
